import App from "./app";
import SubaccountApp from "./subaccount_app";

const routes = [
  {
    type: "collapse",
    key: "app",
    route: "/agency_app",
    component: <App />,
  },
  {
    type: "collapse",
    key: "app",
    route: "/app",
    component: <SubaccountApp />,
  },
];

export default routes;
